import { BehaviorSubject } from 'rxjs';

export enum SwRegistrationSubjectState {
  INIT,
  REGISTER,
  UPDATE,
  SUCCESS,
}

type SwRegistrationSubjectValue =
  | {
      state: SwRegistrationSubjectState.INIT;
      registration: null;
    }
  | {
      state: Exclude<SwRegistrationSubjectState, SwRegistrationSubjectState.INIT>;
      registration: ServiceWorkerRegistration;
    };

export const swRegistrationSubject = new BehaviorSubject<SwRegistrationSubjectValue>({
  state: SwRegistrationSubjectState.INIT,
  registration: null,
});
